module.exports = __webpack_public_path__ + "img/logo-PRTG-tmp.88ed7ea4.svg";